module.exports = __webpack_public_path__ + "img/pay.004a026b.png";